export default "__VITE_ASSET__Cx4jrshD__"